import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Pressable, StyleSheet } from 'react-native';
import { API } from '@xbto/api-client';
import { theme } from '@xbto/design-system';
import { Col, TextBody } from '../../atoms';
import { ActionIcon } from '../action-icon';
const iconByAccountType = {
    [API.AccountType.Custody]: 'Shield',
    [API.AccountType.Fund]: 'Work',
    [API.AccountType.Interest]: 'SyncAlt',
    [API.AccountType.Pool]: 'SyncAlt',
    [API.AccountType.ProTrading]: 'SyncAlt',
    [API.AccountType.Trading]: 'SyncAlt',
    [API.AccountType.Vault]: 'Shield',
};
export function AccountButton({ account, onPress }) {
    // Vars
    const icon = iconByAccountType[account.accountType];
    // Render
    return (_jsx(Pressable, { disabled: !onPress, onPress: onPress, style: ({ pressed }) => [$.container, pressed && $.active], children: ({ pressed }) => (_jsxs(_Fragment, { children: [_jsx(ActionIcon, { name: icon }), _jsxs(Col, { style: $.content, children: [_jsx(TextBody, { em: true, color: pressed ? 'inverse' : 'primary', children: account.label }), _jsx(TextBody, { small: true, mt: "1", color: pressed ? 'inverse' : 'secondary', children: account.accountNumber })] })] })) }));
}
const $ = StyleSheet.create({
    container: {
        borderRadius: theme.radius.sm,
        backgroundColor: theme.color.background.tertiary,
        padding: theme.spacing['4'],
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.spacing['4'],
    },
    content: {
        flex: 1,
    },
    active: {
        backgroundColor: theme.color.background.primary,
    },
});
